import { Alert, Stack } from "@mui/material";
import { useRouteError } from "react-router-dom";
import { isAxiosError } from "utils/helpers";

export function ReplacementFinderPageError() {
  const error = useRouteError();

  function ErrorMessage() {
    if (isAxiosError(error)) {
      if (error.response?.status === 404)
        return <Alert severity="warning">Could not fetch inventory: {error.response.statusText}</Alert>;
      if (error.response?.status === 500)
        return (
          <Alert severity="error">
            Error: {error.response.status}
            <br />
            {error.response.data.error?.message}
            {error.message}
            <br />
            {error.cause instanceof Error ? error.cause.message : null}
            <br />
            {error.stack}
          </Alert>
        );
    }

    return <Alert severity="error">An unknown error occurred.</Alert>;
  }

  return (
    <Stack justifyContent="center" margin={2}>
      <ErrorMessage />
    </Stack>
  );
}
